import React from 'react';
import { SubHeading } from '../../components';
import { images } from '../../constants';
import './Header.css';

const Header = () => (
  <div className='app__header app__wrapper section__padding' id='home'>
    <div className='app__wrapper_info'>
      < SubHeading title='Auténtico sabor de Japón'/>
      <h1 className='app__header-h1'>Kawaii Sushi</h1>
      <p className='p__opensans' style={{ marginBottom: '2rem'}}>Sumérgete en nuestras preparaciones niponas.</p>
      <button type='button' className='custom__button'><a href="#menu">Revisa el menú</a></button>

    </div>
    <div className='app__wrapper_img'>
      <img src={images.welcome} alt='header img'/>
    </div>


  </div>
);

export default Header;
